import React, { Component } from 'react';
import {withTranslation} from 'react-i18next';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import Wrp from "../../../hoc/Wrp/Wrp";
import BasicDetails from './BasicDetails';
import HtmlContent from './HtmlContent';
import {getValueFromOptions,isSet} from '../../../Utils/CommonFunctions';
import CreateNewVariable from './HtmlContent/CreateVariable';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { withRouter } from 'react-router';
import PdfTagList from './HtmlContent/PdfTagList';
import AceEditor from "react-ace";
import ImageDetails from './HtmlContent/ImageDetails';
import { getCurrentModuleId } from '../../../Utils/UserFunctions';
import HtmlPdfPReview from '../HtmlPdfPReview';
import PdfWindowFieldTagList from './HtmlContent/PdfWindowFieldTagList';
import {getWindowNameUsingDefinedName} from '../../../Utils/UserFunctions';
import HtmlBuilder from '../../../Components/HtmlBuilder';
import BuilderHoc from '../../../Components/HtmlBuilder/BuilderHoc';


class PDFCreate extends Component {

	state = {
		breadCrumbs:{},
		rulesModel:false,
		pdfdata:{
			id : null,
			designName : '',
			description : '',
			isActive : true,
			isDefault : true,
			htmlContent : '',
			iterateData : {},
			format:'A4',
			width:210,
			height:297,
			formatOptions: [{value:'A0',label:'A0',width:841,height:1189},{value:'A1',label:'A1',width:594,height:841},{value:'A2',label:'A2',width:420,height:594},{value:'A3',label:'A3',width:297,height:420},{value:'A4',label:'A4',width:210,height:297},{value:'A5',label:'A5',width:148,height:148},{value:'Letter',label:'Letter',width:216,height:279},{value:'Legal',label:'Legal',width:216,height:330},{value:'Tabloid',label:'Tabloid',width:841,height:1189},{value:'Custom',label:'Custom',width:0.00,height:0.00}],
			designName_error:'',
			is_window:false,
        	window_id:''
		},
		drillDownData:{
			parentFieldArr : []
		},
		windowFields:[],
		windowFieldsBackup:[],
		previewData:{
			isModalOpen : false
		},
		iterateData:{},
		absoluteWindow:[],
		imageData:{
			id : null,
			data : []
		},
		orgWindowName:'',
		variableList:[],
		variableListBackup:[],
		isVariableModalOpen:false,
		variablesAndFields:[],
		windowsList:[],
		pdfDetails:null,
		htmlContentData:{
			drillDownData:[],
			htmlContent:'',
			absoluteWindow:[],
			iterateData:{},
			imageData:{
				id : null,
				data : []
			},
			htmlBuilderObj:''
		},
		editorType:'MANUAL',
		convertedHtmldata:null
	}
	uploadMultipleFiles = React.createRef();

	componentWillMount() {
	    this.setState({
	      breadCrumbs: {
	          backHistory : [{
	          href : "/settings",
	          name:"Settings"
	          },{
	          href : "/pdf/pdf-list",
	          name:"PDF Template List"
	          }],
	          pageTitle:"PDF Template",
	          buttonList:[
	          {
	              clickHandler:this.previewModaltoggleHandler,
	              attributes:{
	                className:"btn secondary_bg mr-1"
	              },
	              name:"Preview",
	              type:"cancel"
	          },
	          {
	              href:"/settings/",
	              attributes:{
	                className:"btn secondary_bg mr-1"
	              },
	              name:"Cancel",
	              type:"cancel"
	          },
	          {
	              clickHandler: this.saveHandler,
	              attributes:{
	                className:"btn primary_bg"
	              },
	              name:"Save",
	              type:"save"
	          }
	          ]
	      }
	    });
	    this.fetchVariableList();
	    this.variableAndFieldList();
	    this.fetchWindowList();
	    this.fetchPdfDetail();
	  }
	  toogleEditorTypeHandler = (type,data)=>{
		console.log('data',data);
		this.setState({editorType:type,convertedHtmldata:data});
	  }
	render() {
		const {variableList,isVariableModalOpen,variablesAndFields,windowsList,htmlContentData,pdfDetails,windowFields} = this.state;
		const {breadCrumbs,pdfdata,rules} = this.state;
		const {onChangeHandler,rulesToggleHandler} = this;
		console.log('isPreviewModalOpen',this.state.isPreviewModalOpen)
		let builderObject = {
			breadCrumbsList:breadCrumbs,
			variableList:variableList,			
     		drillDownNextLevel:this.drillDownNextLevel,
     		goBackDrillDown:this.goBackDrillDown,
     		htmlContentData:htmlContentData,     		
			isPreviewModalOpen:this.state.isPreviewModalOpen,
			previewModaltoggleHandler:this.previewModaltoggleHandler,
			saveFromHTMLBuilder:this.saveFromHTMLBuilder,
			failMessage:this.props.failMessage,
			succMessage:this.props.succMessage,
			pdfDetails:pdfDetails,
			toggleVariableModel:this.toggleVariableModel
		}

		
		
		return(
		<Wrp>
			{/* <BreadCrumbs 
                breadCrumbsList={breadCrumbs} 
            /> */}
			{(this.state.editorType==='BUILDER')?
            <HtmlBuilder 
				pageFrom='PDF'
				toogleEditorTypeHandler={this.toogleEditorTypeHandler}
				builderObject={builderObject}	
				editorType={this.state.editorType}	
				convertedHtmldata={this.state.convertedHtmldata}								
			/>
			:
			<>
			<BuilderHoc
            breadCrumbs={breadCrumbs}
            viewTypes={[]}
            editorType={this.state.editorType}
			convertedHtmldata={this.state.convertedHtmldata}		
			htmlContentItems={this.state.htmlContentData.htmlContent}
            toogleEditorTypeHandler={this.toogleEditorTypeHandler}
            pageFrom={''}>
            {/* <div className="viewport"> */}
				<div className="view view-xl">
					<div className="outerPort">
						<div className="card-body">
							<div className="row">
								<div className="col-12 " ref={this.props.refAtt}>
							        <div className="card mb-0">
							          <div className="card-header p-2">
							            <div className="card-title"> HTML Content </div>
						              </div>
									  {/* <div className="quick-sidebar-overlay"></div> */}
									  {/* <div className="quick-sidebar p-0" style={{right:'0px'}}> */}
									  {/* <a className="close-quick-sidebar" style={{top:'0px',right:'10px',zIndex:'1'}}><i className="fas fa-times fa-lg"></i></a>

									  </div> */}
							          <div className="card-body pb-0">
							            <div className="d-flex">
							            {pdfDetails && pdfDetails.is_variable_mapping && pdfDetails.is_variable_mapping === true ?
							            	<PdfTagList 
							             		variableList={variableList}
							             		toggleVariableModel={this.toggleVariableModel}
							             		fetchVariableList={this.fetchVariableList}
							             		drillDownNextLevel={this.drillDownNextLevel}
							             		goBackDrillDown={this.goBackDrillDown}
							             		htmlContentData={htmlContentData}
							             		insertTextHandler={this.insertTextHandler}
							             		checkIterateColumns={this.checkIterateColumns}
							             		insertGroupTextHandler={this.insertGroupTextHandler}
							             		getFieldDataUsingId={this.getFieldDataUsingId}
							             		pdfDetails={pdfDetails}
												variableDeleteHandler={this.variableDeleteHandler}
							             	/>
							            :
							            	<PdfWindowFieldTagList 
							             		variableList={variableList}
							             		toggleVariableModel={this.toggleVariableModel}
							             		fetchVariableList={this.fetchVariableList}
							             		drillDownNextLevel={this.drillDownNextLevel}
							             		goBackDrillDown={this.goBackDrillDown}
							             		htmlContentData={htmlContentData}
							             		insertTextHandler={this.insertTextHandler}
							             		checkIterateColumns={this.checkIterateColumns}
							             		insertWindowFieldGroupTextHandler={this.insertWindowFieldGroupTextHandler}
							             		getWindowFieldDataUsingId={this.getWindowFieldDataUsingId}
							             		pdfDetails={pdfDetails}
							             		windowFields={windowFields}
							             	/>
							            }
							             	
							             	<div className="htmlTextarea pr-1 mr-1">
										        <div className="form-group">
										          <label className="">
										            HTML Code 
										          </label>
										          <div className="customTextArea" id="customTextArea">
										              <AceEditor
										                value={htmlContentData.htmlContent}
										                ref="aceEditor"
										                mode="html"
										                theme="github"
										                fontSize={14}
										                width="100%"
										                name="html_code"
										                showPrintMargin={false}
										                editorProps={{ $blockScrolling: true }}
										                onChange={this.htmlContentChangeHandler} 
										                setOptions={{
										                  fontSize:'14px'
										                  }}
										              />
										          </div>
										        </div>
										  	</div>
										  	<ImageDetails 
								                uploadMultipleFiles={this.uploadMultipleFiles} 
								                uploadFilesHandler={this.uploadFilesHandler}
								                onFileChange={this.onFileChange}
								                imageData={this.state.htmlContentData.imageData}
								                deleteUploadFiles={this.deleteUploadFiles}
								                insertTextHandler={this.insertTextHandler}
								              />
							            </div>
							          </div>
							        </div>
							        <CreateNewVariable
							        	isVariableModalOpen={isVariableModalOpen}
							        	variablesAndFields={variablesAndFields}
							        	windowsList={windowsList}
							        	toggleVariableModel={this.toggleVariableModel}
							        	variableList={variableList}
							        	fetchVariableList={this.fetchVariableList}
							        	{...this.props}
							        />
							      </div>
							</div>

						</div>
					</div>
				</div>			 	 
		 {/* </div> */}
			</BuilderHoc>
			<HtmlPdfPReview 
		        isModalOpen={this.state.isPreviewModalOpen} 
		        toggleHandler={this.previewModaltoggleHandler}
		        pdfdata={this.state.pdfdata}
		        previewScreen="new"
		    />
			</>
			}
			

		    <CreateNewVariable
	        	isVariableModalOpen={isVariableModalOpen}
	        	variablesAndFields={variablesAndFields}
	        	windowsList={windowsList}
	        	toggleVariableModel={this.toggleVariableModel}
	        	variableList={variableList}
	        	fetchVariableList={this.fetchVariableList}
	        	{...this.props}
	        />
		</Wrp>
		)
	}

	previewModaltoggleHandler = () => {
		this.setState({
			isPreviewModalOpen:!this.state.isPreviewModalOpen,
			pdfdata:{
				...this.state.pdfdata,
				htmlContent:this.state.htmlContentData.htmlContent
			}
		});
	}

	saveFromHTMLBuilder = async (htmlData,htmlBuilderObj) => {
		console.log('saveFromHTMLBuilder===',htmlData)
		const updateState = {...this.state};
	    updateState['htmlContentData']['htmlContent']=htmlData;
	    updateState['htmlContentData']['htmlBuilderObj']=htmlBuilderObj;
		await this.setState(updateState);
		await this.saveHandler();		
	}

	saveHandler = () => {
		const params = this.props.match.params;
		const{imageData,iterateData,htmlContent,absoluteWindow,htmlBuilderObj} = this.state.htmlContentData;
		const pdfDetails = this.state.pdfDetails;
		const custom_html = JSON.stringify(htmlBuilderObj);//bodycontent;
		// console.log(pdfDetails); return false;
		let htmlImages = [];
		if(imageData.data) {
			imageData.data.map((arr,i) => {
				const val = {
					id : arr.id,
					value : arr.label
				}
				htmlImages.push(val);
			})
		}

		let iterateDataAbs = iterateData;
		iterateDataAbs['absolute_window'] = absoluteWindow;

		/*let filters = [];
		if(rules) {
			rules.map((arr,ind) => {
				if(arr.table_descriptor_id !== '') {
					arr.line_number = ind+1;
					filters.push(arr);

					if(Array.isArray(arr.values)){
		            	arr.values.map((valItem,valInd) => {
		            		valItem.line_no = valInd+1;
		                })
		            }
				}
			})
		}*/

		const body = {
			id:params.pdfTemplateId,
			html_content: htmlContent,
			custom_html : custom_html,
			images: htmlImages,
			more_info: iterateDataAbs,
			design_name: pdfDetails.design_name,
			description: pdfDetails.description,
			is_active: pdfDetails.is_active,
			is_default: pdfDetails.is_default,
			format: pdfDetails.format,
			width: pdfDetails.width,
			height: pdfDetails.height,
			module_id: getCurrentModuleId(),
			is_variable_mapping:pdfDetails.variable_mapping,
			window_id:pdfDetails.window_id
		}
		console.log(JSON.stringify(body),pdfDetails);
		// return false;
		this.props.Loader();
		const header = { 'Content-Type': 'application/json' }

		callPUT("htmltopdf-design/"+params.pdfTemplateId+"/update",body,header)
	    .then(response => {
	      this.props.Loader();
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.props.succMessage(responseData.message);
	        // this.props.history.push("/settings/"+params.windowName+"/"+params.windowId+'/pdf-creation');
	      }else {
	      	// let violations = responseData.violations;
	      	// let errMsg = [];
            // if(violations && violations.length > 0){
            // 	const data = {...pdfdata};
		    //   	violations.map((item,ind) => {
		    //   		data[item['field_name']+'_error'] = item['message'];
	        //         errMsg.push(item['field_name']+' : '+item['message'])
	        //     })
	        //     setPDFData(data);
	      	// }else {
	      	// 	props.failMessage(responseData.message);	
	      	// }
	      	
	      }
    	})
	    .catch(err => {
	      this.props.Loader();
	      this.props.failMessage("Error occured");
	      console.log(err);
	    })
	}

	onChangeHandler = (e,fName='') => {
		const data = {...this.state.pdfdata};
		if(fName !== '') {
			data[fName] = e;
			const optionVal = getValueFromOptions(e,data.formatOptions);
			if(optionVal) {
				data['width'] = optionVal.width;
				data['height'] = optionVal.height;
			}
		}else {
			let { name, value } = e.target;
			if(name === 'isActive' || name === 'isDefault')
				value = e.target.checked;
			data[name] = value;
			if(data[name+'_error']) {
				data[name+'_error'] = '';
			}
		}
		this.setState({
			...this.state.pdfdata,
			pdfdata:data
		})
	}

	fetchVariableList = () => {
		const params = this.props.match.params;
	    callGET("variable/paginated-search?functionType=PDF&referenceId="+params.pdfTemplateId)
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variableList:responseData.data.content,variableListBackup:responseData.data.content})
	      }else{
			this.setState({variableList:[],variableListBackup:[]})
		  }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

	variableAndFieldList = () => {
	    callGET("rates/field-type-list")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variablesAndFields:responseData.data});
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}
	  variableDeleteHandler=(id)=>{
		callDELETE("variable/" + id + "/delete").then(response=>{
				const responseData = response.data;
				if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
					this.props.succMessage("Sucessfully delete the variable")
					this.fetchVariableList();
				}
			  }, (error) => {
				this.props.failMessage("Something went wrong..");
			  })
	}

  	fetchWindowList = () => {
	    callGET("windows/list?query=&page=0&orderBy=display_name&size=10000&direction=ASC")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({windowsList:responseData.data.windows.content})
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

  	toggleVariableModel = () => {
  		this.setState({isVariableModalOpen:!this.state.isVariableModalOpen});
  	}

  	insertTextHandler = (content, type, dependentWindowName='') => {
	    const params = this.props.match.params;
	    let textToInsert = '';
	    if(type === 'img') {
	      textToInsert = content;
	    }else {
	      if(dependentWindowName !== '') {
	        textToInsert = '${'+dependentWindowName+'.'+content+'}';
	      }else {
	        textToInsert = '${'+content+'}';  
	      }
	    }
	    const reactAceComponent = this.refs.aceEditor;
	    
	    const editor = reactAceComponent.editor;
	    var cursorPosition = editor.getCursorPosition();
	    editor.getSession().insert(cursorPosition,textToInsert);
	    // if(dependentWindowName !== '')
	    //   this.props.absoluteWindowHandler(params.windowName+'.'+dependentWindowName);
  	}

	drillDownNextLevel = (parentData) => {
		const prntData = JSON.parse(parentData);
		const {pdfDetails} = this.state;
		const updateState = {...this.state};
		updateState['htmlContentData']['drillDownData'].push(prntData);
		if(pdfDetails && pdfDetails.is_variable_mapping && pdfDetails.is_variable_mapping === true) {
			updateState['variableList']=prntData.fields;
		}else {
			if(prntData.field_type==="PickList") {
				const tempFields = [{
								id:prntData.id+"#n",
                                api_field_name:"name",
                                field_name:"Name",
                                field_type:"PickList1"
                            },{
                            	id:prntData.id+"#v",
                               	api_field_name:"value",
                                field_name:"Value",
                                field_type:"PickList1"
                            }]
				updateState['windowFields']=tempFields;
			}else {
				updateState['windowFields']=prntData.dependent_layout.fields_with_filters.window_fields;		
			}
		}
		
		this.setState(updateState);
	}

	goBackDrillDown = (itemInd) => {
		const {pdfDetails} = this.state;
		const updateState = {...this.state};
	    let drillData = updateState['htmlContentData']['drillDownData'];
	    let existData = this.state['htmlContentData']['drillDownData'];
	    const slicedArray = existData.slice(0, itemInd+1);
	    let variableList = [];
	    if(pdfDetails && pdfDetails.is_variable_mapping && pdfDetails.is_variable_mapping === true) {
		    if(itemInd !== -1) {
		      drillData = slicedArray;
		      if(slicedArray.length > 0) {
		      	variableList = slicedArray[slicedArray.length-1].fields;
		      }else {
		      	variableList = variableList;
		      }
		    }else {
		      drillData = [];
		      variableList = updateState.variableListBackup;
		    }
		    updateState['variableList']=variableList;
		}else {
			if(itemInd !== -1) {
		      drillData = slicedArray;
		      console.log(slicedArray);
		      if(slicedArray.length > 0) {
		      	if(slicedArray[slicedArray.length-1].field_type !== "PickList") {
		      		variableList = slicedArray[slicedArray.length-1].dependent_layout.fields_with_filters.window_fields;	
		      	}else{
		      		return false;
		      	}
		      }else {
		      	variableList = variableList;
		      }
		    }else {
		      drillData = [];
		      variableList = updateState.windowFieldsBackup.fields_with_filters.window_fields;
		    }
		    updateState['windowFields']=variableList;
		}
	    updateState['htmlContentData']['drillDownData'] = drillData;
		
		this.setState(updateState);
  	} 

  	htmlContentChangeHandler = (newValue) => {
	    let dependentWindowName = '';
	    const parentFieldArr = this.state.htmlContentData.drillDownData;
	    if(parentFieldArr && parentFieldArr.length > 0) {
	        parentFieldArr.map((pArr,pInd) => {
	          dependentWindowName +=  dependentWindowName === '' ? pArr.api_name : '.'+pArr.api_name;
	        })
	    }
	    const updateState = {...this.state};
	    updateState['htmlContentData']['htmlContent']=newValue;
	    if(dependentWindowName !== '') {
	    	if(this.state.htmlContentData.absoluteWindow.indexOf(dependentWindowName) === -1) {
				const data = this.state.htmlContentData.absoluteWindow;
				data.push(dependentWindowName);
				updateState['htmlContentData']['absoluteWindow'] = data;
			}
	    }
	    this.setState(updateState);
  	}

	insertGroupTextHandler = (dependentWindowName) => {
	    const iterateData = this.state.htmlContentData.iterateData;
	    const reactAceComponent = this.refs.aceEditor;
	    const editor = reactAceComponent.editor;
	    var cursorPosition = editor.getCursorPosition();
	    let textToInsert = '';
	    let dependentWindowNameVal = dependentWindowName
	    if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')]) {
	      if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].length > 0) {
	        iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].map((arr,i) => {
	          const fieldData = this.getFieldDataUsingId(arr);
	          textToInsert += '${'+dependentWindowName+'.'+fieldData.api_name+'} ';  
	        })
	      }
	    }

	    if(textToInsert !== '') {
	      textToInsert = '<x-'+dependentWindowName.replaceAll('.','-')+'>'+textToInsert+'</x-'+dependentWindowName.replaceAll('.','-')+'>';
	    }
	    editor.getSession().insert(cursorPosition,textToInsert);
  	}

  	insertWindowFieldGroupTextHandler = (dependentWindowName) => {
	    const iterateData = this.state.htmlContentData.iterateData;
  		console.log(dependentWindowName,iterateData);
	    const reactAceComponent = this.refs.aceEditor;
	    const editor = reactAceComponent.editor;
	    var cursorPosition = editor.getCursorPosition();
	    let textToInsert = '';
	    //const windowName = getWindowNameUsingDefinedName(this.state.pdfDetails.window_name);
	    //let dependentWindowNameVal = windowName+'-'+dependentWindowName
	    let dependentWindowNameVal = dependentWindowName;
	    if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')]) {
	      if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].length > 0) {
	        iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].map((arr,i) => {
	          const fieldData = this.getWindowFieldDataUsingId(arr);
	          textToInsert += '${'+dependentWindowName+'.'+fieldData.api_field_name+'} ';  
	        })
	      }
	    }

	    if(textToInsert !== '') {
	      textToInsert = '<x-'+dependentWindowName.replaceAll('.','-')+'>'+textToInsert+'</x-'+dependentWindowName.replaceAll('.','-')+'>';
	    }
	    editor.getSession().insert(cursorPosition,textToInsert);
  	}

	getFieldDataUsingId = fieldId => {
	    let returnVal = '';
	    if(this.state.variableList) {
	      this.state.variableList.map((arr,ind) => {
	        if(arr.id === fieldId) {
	          returnVal = arr;
	        }
	      })
	    }
	    return returnVal;
  	}

  	getWindowFieldDataUsingId = fieldId => {
	    let returnVal = '';
	    if(this.state.windowFields) {
	      this.state.windowFields.map((arr,ind) => {
	        if(arr.id === fieldId) {
	          returnVal = arr;
	        }
	      })
	    }
	    return returnVal;
  	}

  	checkIterateColumns = (e) => {
  		const {name,value,checked} = e.target;
		console.log(value);
		const {pdfDetails} = this.state;
		const  parentFieldArr = this.state.htmlContentData.drillDownData;
		const depLayout = parentFieldArr[parentFieldArr.length-1].dependent_layout;
		const windowName = getWindowNameUsingDefinedName(this.state.pdfDetails.window_name);
		let dependentWindowName = '';
	 	parentFieldArr.map((pArr,pInd) => {
	 		if(pdfDetails && pdfDetails.is_variable_mapping && pdfDetails.is_variable_mapping === true) {
	        	dependentWindowName +=  dependentWindowName === '' ? 'x-'+pArr.api_name : '-'+pArr.api_name;
	    	}else {
	    		dependentWindowName +=  dependentWindowName === '' ? 'x-'+windowName+'-'+pArr.api_field_name : '-'+pArr.api_field_name;
	    	}
      	})
		const list = {...this.state.htmlContentData.iterateData}

		if(checked === true) {
			if(list[dependentWindowName]) {
				list[dependentWindowName].push(value);
			}else {
				list[dependentWindowName] = [];
				list[dependentWindowName].push(value);	
			}
		}else {
			// const windIndex = list[dependentWindowName].indexOf(value);
			// list[dependentWindowName].splice(windIndex, 1);
		}
		this.setState({
			htmlContentData:{
				...this.state.htmlContentData,
				iterateData:list
			}
		})
	}

	deleteUploadFiles = (ind) => {
		let updateFiles = this.state['htmlContentData']['imageData']['data'];
		updateFiles = updateFiles.filter((item,index)=>{
			if(index!== ind){
			  return item;
			}
		})
		const updateState = {...this.state};
        updateState['htmlContentData']['imageData']['data'] = updateFiles ? updateFiles : [];
        this.setState(updateState);
	}

  	onFileChange =()=>{
      let inputField = this.uploadMultipleFiles;
      inputField.click();
    }  

  	uploadFilesHandler = (e) => {
      this.uploadFileAPICall(e.target.files);
    }

    uploadFileAPICall= (files)=>{
		let totalFileLength = files.length;
      	Object.entries(files).map(([key, fileItem]) => {
	        const formData = new FormData();            
	        formData.append("upload_file", fileItem);
	        const APIURL = 'files/upload';
	        callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
	        .then(res => {    
	          if(res.status==200){                        
	            const response = res.data;
	            if(response.code === ShipConstants.API_STATUS_SUCCESS) { 
	                const responseData =  response.data;
	                const updateState = {...this.state};
	                const data = { id : responseData, label : responseData , file : fileItem};
	                updateState['htmlContentData']['imageData']['data'].push(data);
	                this.setState(updateState);
	              }else{
	                // this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
	              }                                                
	          }else{
	              // this.props.Loader();
	              // this.props.failMessage('Something went wrong..');
	          }
	        })
	        .catch(err => {
	            console.log(err);
	            // this.props.Loader();
	            // this.props.failMessage('Something went wrong');                    
	        })
	    })
  	}

  	fetchPdfDetail = () => {
		const params = this.props.match.params;
		callGET('htmltopdf-design/'+params.pdfTemplateId+'/view')
		.then(response => {
			const responseData = response.data;
			if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
				const editData = response.data.data;
				const updateState = {...this.state};
				updateState['pdfDetails'] = editData;
				updateState['breadCrumbs']['pageTitle'] = editData.design_name;
				const {imageData} = this.state.htmlContentData;
				const data1 = imageData;
				data1['data'] = editData.images ? editData.images : []; 
				updateState['htmlContentData']['imageData'] = data1;
				updateState['htmlContentData']['htmlContent'] = editData.html_content;
				updateState['htmlContentData']['htmlBuilderObj'] = isSet(editData.custom_html,undefined)!==undefined?JSON.parse(editData.custom_html):'';
				if(editData.more_info) {
					updateState['htmlContentData']['iterateData'] = editData.more_info;
					if(editData.more_info['absolute_window']) {
						updateState['htmlContentData']['absoluteWindow'] = editData.more_info['absolute_window'];
					}
				}
				console.log(updateState);
				this.setState(updateState);

				if(editData && editData.is_variable_mapping === false && editData.window_id && editData.window_id !== "") {
					this.generateFields(editData.window_id);
				}
			}
		})
		.catch(err => {
			this.props.Loader(false);
	    })	
	}

	generateFields = (windowId) => {
		this.props.Loader();
		callGET('field-groups/window/'+windowId+'/lookup-layouts')
		.then(response => {
			this.props.Loader();
			const responseData = response.data;
			if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
				const windowResponseData = responseData.data;
	    		if(windowResponseData.fields_with_filters) {
	    			this.setState({
	    				windowFields:windowResponseData.fields_with_filters.window_fields,
	    				windowFieldsBackup:windowResponseData
	    			})
	    		}
			}
		})
		.catch(err => {
	      this.props.Loader();
	      this.props.failMessage("Error occured");
	      console.log(err);
	    })
	}	
	
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(null, mapDispatchToProps)(withRouter(PDFCreate));